import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { PATH_ROUTES } from 'routes/path';

export default function useActiveNav() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const [activeNav, setActiveNav] = useState<string>('');

  const navMapper = useMemo(
    () => [
      {
        name: t('dashboard'),
        paths: [PATH_ROUTES.DASHBOARD],
      },
      {
        name: t('face_scan_reports'),
        paths: [
          PATH_ROUTES.FACE_SCAN,
          PATH_ROUTES.START_FACE_SCAN,
          PATH_ROUTES.FACE_SCAN_RESULT,
        ],
      },
      {
        name: t('voice_scan'),
        paths: [PATH_ROUTES.VOICE_SCAN, PATH_ROUTES.START_VOICE_SCAN],
      },
      {
        name: t('personalised_ai_reports'),
        paths: [
          PATH_ROUTES.PERSONALISED_AI_REPORT,
          PATH_ROUTES.GENERATE_AI_REPORT,
        ],
      },
      {
        name: t('interpret_lab_reports'),
        paths: [
          PATH_ROUTES.INTERPRET_LAB_REPORT,
          PATH_ROUTES.GENERATE_LAB_REPORT,
        ],
      },
      {
        name: t('profile'),
        paths: [PATH_ROUTES.PROFILE],
      },
      {
        name: t('symptom_checker'),
        paths: [
          PATH_ROUTES.SYMPTOM_CHECKER,
          PATH_ROUTES.GENERATE_SYMPTOM_CHECKER,
        ],
      },
      {
        name: t('risk_checker'),
        paths: [
          PATH_ROUTES.RISK_ANALYSIS,
          PATH_ROUTES.RISK_ANALYSIS_SCAN,
          PATH_ROUTES.RISK_ANALYSIS_DETAIL,
          PATH_ROUTES.RISK_ANALYSIS_QUESTIONNAIRE,
        ],
      },
      {
        name: t('notification'),
        paths: [PATH_ROUTES.NOTIFICATION, PATH_ROUTES.NOTIFICATION_DETAIL],
      },
    ],
    []
  );

  useEffect(() => {
    let navName = navMapper.find((nav) => nav.paths.includes(pathname))?.name;
    if (pathname.includes('/helpdesk-tickets')) {
      navName = t('help_desk');
    }
    setActiveNav(navName || '');
  }, [pathname]);

  return { activeNav };
}
